module.exports = __webpack_public_path__ + "static/media/logo_solides.76f5a333.svg";